/**
 * Shared copy for the express register funnel.
 */

export const EXPRESS_REGISTER_HEADLINE = 'Register in under a minute';

export const EXPRESS_REGISTER_BODY =
  'Use your email to reserve a seat for eligible APT-hosted training without a full signup wall.';

export const EXPRESS_REGISTER_BULLETS = [
  'Fast checkout for eligible free training events hosted on American Police Training.',
  'Confirmation and receipt details go to your email.',
  'Create an account later to manage registrations faster across devices.',
] as const;

export const EXPRESS_REGISTER_PRIMARY_CTA = 'Register now';

export const EXPRESS_REGISTER_SECONDARY_CTA = 'Sign in for full account tools';

export const EXPRESS_REGISTER_SUCCESS_UPGRADE_PITCH =
  'Create an account to manage registrations, certificates, and alert settings from your dashboard.';

/** Modal chrome. */
export const EXPRESS_REGISTER_MODAL_TITLE = 'Reserve your seat';
export const EXPRESS_REGISTER_MODAL_SUBMIT_CTA = 'Reserve my seat';
export const EXPRESS_REGISTER_MODAL_SUBMITTING_CTA = 'Reserving…';
export const EXPRESS_REGISTER_MODAL_CANCEL_CTA = 'Cancel';

/** Field labels and helper text. */
export const EXPRESS_REGISTER_FIELD_FIRST_NAME = 'First name';
export const EXPRESS_REGISTER_FIELD_LAST_NAME = 'Last name';
export const EXPRESS_REGISTER_FIELD_EMAIL = 'Work email';
export const EXPRESS_REGISTER_FIELD_PHONE = 'Phone (optional)';
export const EXPRESS_REGISTER_FIELD_AGENCY = 'Agency or department (optional)';

export const EXPRESS_REGISTER_EMAIL_HELPER =
  'Your confirmation and seat details go here.';
export const EXPRESS_REGISTER_PHONE_HELPER =
  'Only used if the host needs to reach you about this training.';
export const EXPRESS_REGISTER_AGENCY_HELPER =
  'Helps the host verify who is attending.';

/** Success panel. */
export const EXPRESS_REGISTER_SUCCESS_TITLE = 'You’re registered';
export const EXPRESS_REGISTER_SUCCESS_BODY =
  'Check your email for the confirmation and seat details.';
export const EXPRESS_REGISTER_SUCCESS_CLAIM_CTA = 'Create my account';
export const EXPRESS_REGISTER_SUCCESS_ALERTS_CTA = 'Get alerts for new training';
export const EXPRESS_REGISTER_SUCCESS_BROWSE_CTA = 'Browse more training';

/** Errors. */
export const EXPRESS_REGISTER_DUPLICATE_MESSAGE =
  'That email is already registered for this training. Check your inbox for the confirmation, or sign in to manage your seat.';
export const EXPRESS_REGISTER_GENERIC_ERROR =
  'We couldn’t complete your registration. Try again in a moment.';
export const EXPRESS_REGISTER_UNAVAILABLE_MESSAGE =
  'Express registration isn’t available for this training. Create an account to register.';
export const EXPRESS_REGISTER_RATE_LIMITED_MESSAGE =
  'Too many registration attempts from this network. Wait a few minutes and try again.';
export const EXPRESS_REGISTER_FULL_MESSAGE =
  'This training is at capacity. Create an account to join the waitlist.';

/** Sticky mobile bar. */
export const EXPRESS_REGISTER_STICKY_CTA = 'Register — free';
